import React from "react"
import { useState } from "react"
import Axios from "axios"
import PokeView from "./PokeView"

export default function Main() {
    const [pokemonName, setPokemonName] = useState("")

    // default Pokemon is Grovyle :)
    const [pokemon, setPokemon] = useState({
        name: "GROVYLE",
        img: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/253.png",
        type_1: "grass",
        type_2: "nil",
        hp: 50,
        attack: 65, 
        defense: 45,
        special_attack: 85,
        special_defense: 65,
        speed: 95,
        abilities: [{ability: {name: "Overgrow"}}, {ability: {name: "Unburden"}}]
    })

    function handleChange(event) {
        setPokemonName(event.target.value)
    }

    function searchPokemon(event) {
        event.preventDefault()
        Axios.get(`https://pokeapi.co/api/v2/pokemon/${pokemonName.trim().toLowerCase()}`)
            .then((response) => {
                // only interested in data
                let mon = response.data

                setPokemon({
                    name: mon.name.toUpperCase(),
                    img: mon.sprites.other['official-artwork'].front_default,
                    type_1: mon.types[0].type.name,  
                    type_2: mon.types[1] ? mon.types[1].type.name : "nil",
                    hp: mon.stats[0].base_stat,
                    attack: mon.stats[1].base_stat,
                    defense: mon.stats[2].base_stat,
                    special_attack: mon.stats[3].base_stat,
                    special_defense: mon.stats[4].base_stat,
                    speed: mon.stats[5].base_stat,
                    abilities: mon.abilities
                })
            })
            .catch((error) => {
                // catching errors (needed documentation for this one!)
                alert("Sorry! No such Pokémon exists!")
                console.log(error)
            })
    }

    return (
        <div>
            <div className="header">
                <h1>pokéSearch</h1>
                <input 
                    className="input"
                    placeholder="Enter Pokémon's name here..."
                    autoComplete="off"
                    value={pokemonName}
                    onChange={handleChange}
                />
                <button
                    className="submit"
                    onClick={searchPokemon}
                >SEARCH</button>
            </div>
            <br></br>
            <PokeView pokemon={pokemon}/>
            <br></br>
            <h2 className="footer">Why Grovyle as the default? It's my favourite Pokémon...</h2>
            <br></br>
        </div>
    )
}